import { Component } from "react";
import {FaShoppingCart} from 'react-icons/fa';


export class ProductsList extends Component{
    render(){
        const discountPrice = (percent, original)=>{
            return original - ((percent*original)/100)
        }
        return(
            <>
            {this.props.product && this.props.product.map((r)=>
            <div key={r.id} className='w-44'>
                <div className="shadow-md overflow-hidden rounded-md">
                    <div className="relative">
                        <img className="w-full h-36 bg-slate-200 object-cover object-center" src={r.images[0]} alt="/"/>
                        <div className="absolute inset-0 bg-slate-500 w-full h-full opacity-0 transition-opacity duration-150 ease-linear hover:opacity-60 flex justify-center items-center">
                            <div onClick={()=>this.props.addToCard(r)} className="bg-blue-900 rounded-full p-2 animate-bounce"><FaShoppingCart className="text-2xl text-yellow-300 opacity-100"/></div>
                        </div>
                        <div className="flex-col">
                            <h4 className="pt-2 text-sm">{r.title}</h4>
                            <p className="text-[30px] text-slate-900">${discountPrice(r.discountPercentage,r.price).toFixed(2)}</p>
                            <del className="text-[15px] text-slate-900">${r.price}</del>  
                        </div>
                    </div>
                </div>
            </div>
            )}
            </>
        )
    }
}